import { Component, ViewEncapsulation, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { KYMW1407ImageInfoDetailBoxComponent } from '../kymw1407-image-info-detail-box/kymw1407-image-info-detail-box.component';

/**
 * 画像情報詳細を管理するクラス
 *
 * @export KYMW1407ImageInfoDetailComponent
 * @class KYMW1407ImageInfoDetailComponent
 */
@Component({
  selector: 'app-kymw1407-image-info-detail',
  templateUrl: 'kymw1407-image-info-detail.component.html',
  styleUrls: ['kymw1407-image-info-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1407ImageInfoDetailComponent {
  @ViewChild('imageInfoDetailBox', { static: true }) imageInfoDetailBox: KYMW1407ImageInfoDetailBoxComponent;

  @Input() goodsImagePreviewURL = String('');

  @Output() eventImageInfoDetailCHANGE: EventEmitter<any> = new EventEmitter;
  // 項番2231 START 障害管理NO.U01970対応
  @Output() changeStartOrderCode: EventEmitter<any> = new EventEmitter;
  @Output() changeEndOrderCode1: EventEmitter<any> = new EventEmitter;
  // 項番2231 END 障害管理NO.U01970対応
  @Output() changeEndOrderCode2: EventEmitter<any> = new EventEmitter;
  @Output() eventSettingCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventResetCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventUseStopCLICK: EventEmitter<any> = new EventEmitter;

  // ボタン非活性フラグ
  public disabledSettingBtn = Boolean(false);
  public disabledResetBtn = Boolean(false);
  public disabledUseStopBtn = Boolean(false);

  /**
   *Creates an instance of KYMW1407ImageInfoDetailComponent.
   * @memberof KYMW1407ImageInfoDetailComponent
   */
  constructor(
  ) {
  }
}
